import { useEffect, useMemo, useState } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { PLPPageProps, PLPReactQueryKeys } from '../types'

export default function usePLPInitialLoading({ searchParams }: PLPPageProps) {
    const [isLoading, setIsLoading] = useState(true)

    const queryClient = useQueryClient()
    const queryKey = useMemo(() => [PLPReactQueryKeys.PagesData, searchParams], [searchParams])

    useEffect(() => {
        const init = async () => {
            await queryClient.refetchQueries({ queryKey, exact: true })

            setIsLoading(false)
        }

        init()
    }, [queryClient, queryKey, searchParams])

    return isLoading
}
